const columnTypes = {
  content: 'content',
  currency: 'currency',
  datePicker: 'datePicker',
  searchableList: 'searchableList',
  text: 'text',
  component: 'component',
}

export default columnTypes
